import GridRow from "./grid_row";
import GridRowForm from "./grid_row_form";

class ServersideGridRow extends GridRow {
    make_search_column(df, colsize) {
		let title = "";
		let input_class = "";
		let is_disabled = "";

		if (["Text", "Small Text"].includes(df.fieldtype)) {
			input_class = "grid-overflow-no-ellipsis";
		} else if (["Int", "Currency", "Float", "Percent"].includes(df.fieldtype)) {
			input_class = "text-right";
		} else if (df.fieldtype === "Check") {
			title = __("1 = True & 0 = False");
			input_class = "text-center";
		} else if (df.fieldtype === "Password") {
			is_disabled = "disabled";
			title = __("Password cannot be filtered");
		}

		let $col = $(
			'<div class="col grid-static-col col-xs-' + colsize + ' search"></div>'
		).appendTo(this.row);

		let $search_input = $(`
			<input
				type="text"
				class="form-control input-xs search-icon-input ${input_class} ${df.fieldname}"
				title="${title}"
				data-fieldtype="${df.fieldtype}"
				${is_disabled}
			>
		`).appendTo($col);

		this.search_columns[df.fieldname] = $col;

		$search_input.on(
			"keyup",
			(e) => {
				this.grid.filter[df.fieldname] = {
					df: df,
					value: e.target.value,
				};
				if (e.target.value == "") {
					delete this.grid.filter[df.fieldname];
					if (e.key === "Delete" || e.key === "Backspace") {
						this.grid.prevent_build = true;
						this.grid.grid_pagination.go_to_page(1);
						this.grid.refresh();
						this.grid.prevent_build = false;
					}
				}
				this.grid.grid_sortable.option(
					"disabled",
					Object.keys(this.grid.filter).length !== 0
				);
				if (e.key === "Enter") {
					
	
					this.grid.prevent_build = true;
					this.grid.grid_pagination.go_to_page(1);
					// this.grid.refresh();
					this.grid.prevent_build = false;
				}
			})
		;

		["Currency", "Float", "Int", "Percent", "Rating"].includes(df.fieldtype) &&
			frappe.utils.only_allow_num_decimal($search_input);

		return $col;
	}

	render_row(refresh) {
		if (this.show_search && !this.show_search_row()) return;

		let me = this;
		this.set_row_index();

		// index (1, 2, 3 etc)
		if (!this.row_index && !this.show_search) {
			// REDESIGN-TODO: Make translation contextual, this No is Number
			var txt = this.doc ? this.doc.idx : __("No.");

			this.row_check = $(
				`<div class="row-check sortable-handle col">
					${this.row_check_html}
				</div>`
			).appendTo(this.row);

			this.row_index = $(
				`<div class="row-index sortable-handle col">
					<span>${txt}</span>
				</div>`
			)
				.appendTo(this.row)
				.on("click", function (e) {
					if (!$(e.target).hasClass("grid-row-check")) {
						me.toggle_view();
					}
				});
		} else if (this.show_search) {
			this.row_check = $(`<div class="row-check col search"></div>`).appendTo(this.row);

			this.row_index = $(
				`<div class="row-index col grid-static-col search">
					<input type="text"  class="form-control input-xs text-center search-icon-input" >
				</div>`
			).appendTo(this.row);

			this.row_index.find("input").on(
				"keyup",
				(e) => {
					if (e.key === "Enter") {
						let df = {
							fieldtype: "Sr No",
						};
	
						this.grid.filter["row-index"] = {
							df: df,
							value: e.target.value,
						};
	
						if (e.target.value == "") {
							delete this.grid.filter["row-index"];
						}
	
						this.grid.grid_sortable.option(
							"disabled",
							Object.keys(this.grid.filter).length !== 0
						);
	
						this.grid.prevent_build = true;
						me.grid.refresh();
						this.grid.prevent_build = false;
					}
				}
			);
			frappe.utils.only_allow_num_decimal(this.row_index.find("input"));
		} else {
			this.row_index.find("span").html(txt);
		}

		this.setup_columns();
		this.add_open_form_button();
		this.add_column_configure_button();
		this.refresh_check();

		if (this.frm && this.doc) {
			$(this.frm.wrapper).trigger("grid-row-render", [this]);
		}

		return true;
	}

	refresh() {
		// update docfields for new record
		if (this.frm && this.doc && this.doc.__islocal) {
			this.set_docfields(true);
		}

		if (this.frm && this.doc) {
			if(locals[this.doc.doctype][this.doc.name]){
				this.doc = locals[this.doc.doctype][this.doc.name]
			}
		}

		if (this.grid.template && !this.grid.meta.editable_grid) {
			this.render_template();
		} else {
			this.render_row(true);
		}

		// refresh form fields
		if (this.grid_form) {
			this.grid_form.layout && this.grid_form.layout.refresh(this.doc);
		}
	}

	toggle_view(show, callback) {
		if (!this.doc) {
			return this;
		}

		if (this.frm) {
			if(locals[this.doc.doctype][this.doc.name]){
				this.doc = locals[this.doc.doctype][this.doc.name]
			}
		}

		// hide other
		var open_row = this.get_open_form();

		if (show === undefined) show = !open_row;

		// call blur
		document.activeElement && document.activeElement.blur();

		if (show && open_row) {
			if (open_row == this) {
				// already open, do nothing
				callback && callback();
				return;
			} else {
				// close other views
				open_row.toggle_view(false);
			}
		}

		if (show) {
			this.show_form();
		} else {
			this.hide_form();
		}
		callback && callback();

		return this;
	}
}

export default ServersideGridRow;